/**
 * Верхнее меню: лого Techt слева, Homepage и Services по центру (02_GPT-MODULAR).
 * Подсветка активной страницы по текущему пути.
 */

import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import useLogoDevUnlock from "../../hooks/useLogoDevUnlock";
import "./Header.css";
import "./HeaderLogo.css";

function Header() {
    const location = useLocation();
    const path = location.pathname;
    const [menuOpen, setMenuOpen] = useState(false);
    const unlockDev = useLogoDevUnlock();

    useEffect(() => {
        setMenuOpen(false);
    }, [path]);

    useEffect(() => {
        document.body.classList.toggle("nav-open", menuOpen);
        return () => document.body.classList.remove("nav-open");
    }, [menuOpen]);

    return (
        <header className={`header${menuOpen ? " header_menu-open" : ""}`}>
            <Link
                to="/"
                className="header__logo"
                onClick={(event) => {
                    setMenuOpen(false);
                    unlockDev(event);
                }}
            >
                <svg className="header__logo-svg" width="120" height="40" viewBox="0 0 239 81" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path className="logo-accent" d="M58.7499 1.2376C59.2199 0.177604 60.4199 -0.242402 61.2299 0.137598C62.1299 0.547598 62.5599 1.9276 61.8299 2.9976C51.6299 24.6876 41.4399 46.3876 31.2399 68.0776C30.6799 68.9776 29.4999 69.2376 28.6499 68.7076C27.7599 68.1476 27.4999 66.8776 28.1699 65.9776C38.3599 44.3976 48.5599 22.8176 58.7499 1.22761V1.2376Z" fill="#B8FF65"/>
                    <path className="logo-accent" d="M4.75 72.0977C7.37335 72.0977 9.5 69.971 9.5 67.3477C9.5 64.7243 7.37335 62.5977 4.75 62.5977C2.12665 62.5977 0 64.7243 0 67.3477C0 69.971 2.12665 72.0977 4.75 72.0977Z" fill="#B8FF65"/>
                    <path className="logo-main" d="M76.6701 14.5276L93.8701 8.33765V22.6376H120.16L126.54 43.7076L132.73 22.4476H150.32C145.19 36.0576 140.16 49.7377 134.46 63.1377C132.43 67.9177 130.2 72.8376 126.44 76.5276C123.12 79.7976 118.12 80.6377 113.63 80.4377C108.12 80.1977 104.14 77.9277 102.37 76.7577C103.72 73.0877 105.08 69.4076 106.43 65.7376C107.25 66.0576 113.23 68.2777 115.96 65.5077C117.4 64.0577 117.27 61.0577 117.26 60.4977C117.26 60.4977 117.26 59.0677 116.86 57.6377C116.06 54.7177 111.36 44.2277 104.57 30.2977V35.1777H93.3201C93.3901 39.1777 93.4501 43.1877 93.5201 47.1877C93.7201 47.8077 94.4901 49.9077 96.5801 51.0377C99.0801 52.3777 102.46 51.7877 104.9 49.4777L107.34 59.8376C99.5001 66.3176 89.5901 67.0377 83.6701 62.4477C79.7101 59.3777 78.5701 54.7377 78.2101 52.6577V35.3177H70.6201V22.3777H76.9901L76.6401 14.5177L76.6701 14.5276Z" fill="#1A202C"/>
                    <path className="logo-main" d="M194.38 43.1378C194.29 35.8278 190.87 24.0678 181.25 21.4778C174.13 19.5678 167.7 23.7678 166.22 24.7978V5.9978H151.18V63.1678H164.56V58.6378C170.13 63.9678 177.65 65.9678 183.8 63.6178C194.2 59.6478 194.41 45.6278 194.38 43.1478V43.1378ZM177.74 45.6178C177.74 46.8078 177.4 47.9978 176.67 48.9378C175.71 50.1778 174.32 51.0278 172.78 51.2378C170.76 51.5078 168.71 50.6578 167.35 49.0478C166.53 48.0778 166.14 46.8078 166.14 45.5378V39.1578C166.14 38.2578 166.32 37.3578 166.76 36.5778C167.8 34.7478 169.76 33.5578 171.94 33.5578C174.12 33.5578 176.08 34.7578 177.12 36.5778C177.56 37.3578 177.74 38.2578 177.74 39.1578V45.6278V45.6178Z" fill="#1A202C"/>
                    <path className="logo-main" d="M238.66 43.6678C238.66 31.4178 228.95 21.4778 216.98 21.4778C205.01 21.4778 195.3 31.4078 195.3 43.6678C195.3 55.9278 205.62 65.6678 216.98 65.8578C225.62 65.9978 233.82 60.5978 237.76 52.1278C234.4 50.6178 231.05 49.0978 227.69 47.5878H238.32C238.54 46.3178 238.66 45.0078 238.66 43.6678ZM217.45 33.6978C219.59 33.7378 221.48 35.1678 222.1 37.2378H212.63C213.27 35.1078 215.25 33.6578 217.45 33.6978ZM218.27 51.4378C216.01 51.5978 213.86 50.1678 213.08 47.9378H222.72C222.04 49.9078 220.28 51.2978 218.27 51.4378Z" fill="#1A202C"/>
                </svg>
            </Link>
            <button
                type="button"
                className="header__burger"
                aria-label={menuOpen ? "Close menu" : "Open menu"}
                aria-expanded={menuOpen}
                aria-controls="site-nav"
                onClick={() => setMenuOpen((open) => !open)}
            >
                <span className="header__burger-bar" />
                <span className="header__burger-bar" />
                <span className="header__burger-bar" />
            </button>
            <div
                className="header__backdrop"
                hidden={!menuOpen}
                onClick={() => setMenuOpen(false)}
            />
            <nav id="site-nav" className={`header__nav${menuOpen ? " header__nav_open" : ""}`}>
                <Link
                    to="/"
                    className={`header__link ${path === "/" ? "header__link_active" : ""}`}
                >
                    Homepage
                </Link>
                <Link
                    to="/services"
                    className={`header__link ${path === "/services" ? "header__link_active" : ""}`}
                >
                    Services
                </Link>
                <Link
                    to="/pages"
                    className={`header__link ${path === "/pages" ? "header__link_active" : ""}`}
                >
                    Pages
                </Link>
                <Link
                    to="/contact"
                    className={`header__link ${path === "/contact" ? "header__link_active" : ""}`}
                >
                    Contact
                </Link>
            </nav>
        </header>
    );
}

export default Header;
// components/Header/Header.js
